/*
 * Model and reqres' for the custom templates for responses
 */

define(["backbone", "messaging/messenger", "configuration/properties"], function (
  Backbone,
  Messenger,
  Properties,
) {
  var TopicResponseEditorModel = {};

  TopicResponseEditorModel.customTemplate = Backbone.Model.extend({
    defaults: {
      name: "",
      template: "",
    },
    urlRoot: function () {
      //root for when the template is not part of the customTemplates collection
      var kbId = Messenger.reqres.request("active:kb");
      return Properties.rootURL + "/" + kbId + "/customtemplates";
    },
  });

  TopicResponseEditorModel.customTemplates = Backbone.Collection.extend({
    model: TopicResponseEditorModel.customTemplate,
    comparator: function (a, b) {
      return Backbone.textComparator(a, b, "name");
    },
    url: function () {
      var kbId = Messenger.reqres.request("active:kb");
      return Properties.rootURL + "/" + kbId + "/customtemplates";
    },
  });

  //Get a new custom template to edit and save to the server
  Messenger.reqres.setHandler("new:custom:template", function () {
    return new TopicResponseEditorModel.customTemplate();
  });

  //Delete an existing custom template
  Messenger.reqres.setHandler("remove:custom:template", function (templateOrId) {
    let templateModel = null;
    if (typeof templateOrId == "number") {
      templateModel = new TopicResponseEditorModel.customTemplate({
        id: templateOrId,
      });
    } else if (typeof templateOrId == "string") {
      templateOrId = parseInt(templateOrId, 10);
      if (isNaN(templateOrId)) {
        console.error(`Template ID "${templateOrId}" is not a valid ID`);
        return;
      }
      templateModel = new TopicResponseEditorModel.customTemplate({
        id: templateOrId,
      });
    } else if (typeof templateOrId == "object") {
      templateModel = templateOrId;
    } else {
      console.error(`No Template ID found for DeleteCustomTemplateCommand`);
      return;
    }
    templateModel.deleteModel();
    return templateModel;
  });

  //Get all the custom templates from the sever for the active KB
  Messenger.reqres.setHandler("custom:templates", function () {
    var customTemplates = new TopicResponseEditorModel.customTemplates();
    customTemplates.fetch();
    return customTemplates;
  });
});
